import {
  Component,
  computed,
  effect,
  ElementRef,
  HostListener,
  Inject,
  Input,
  input,
  OnInit,
  output,
  signal,
  DOCUMENT
} from '@angular/core'

import {FormsModule, ReactiveFormsModule} from "@angular/forms"
import {AddressDTO} from "../../../interfaces";



@Component({
    selector: 'app-search-address',
    imports: [
        ReactiveFormsModule,
        FormsModule
    ],
    templateUrl: './search-address.component.html',
    standalone: true,
    styleUrl: './search-address.component.scss'
})
export class SearchAddressComponent implements OnInit{
  addressId = input(-1)
  addresses = input.required<AddressDTO[]>()
  addressText = signal('')
  @Input() labelName: string = 'Address';
  @Input() deliveredQty: number = -1
  isEmpty = output<boolean>();

  selectedAddress = output<number>()
  addressRemoved = output<void>()

  isListVisible: boolean = false

  constructor(@Inject(DOCUMENT) private document: Document, private elementRef: ElementRef) {
    effect(() => {
      if (this.addressId() > 0) {
        const address = this.options().find((address) => address.id === this.addressId())
        if (address) {
          this.addressText.set(address.text)
        }
      }

      this.checkIfAddressesEmpty();
    }, {allowSignalWrites: true});
  }

  ngOnInit() {
    this.checkIfAddressesEmpty();
  }

  checkIfAddressesEmpty() {
    const addressesEmpty = this.addresses().length === 0;
    this.isEmpty.emit(addressesEmpty);
  }

  options = computed(() => {
    return this.addresses().map(address => ({
      id: address.addressId,
      text: this.processAddress(address),
      status: address.status
    }))
  })

  processAddress = (address: AddressDTO) => {
    let txt_address = '';
    if (address.addressLineOne?.trim()) {
      txt_address += `${address.addressLineOne.trim()}${address.addressLineOne.trim().endsWith(',') ? ' ' : ', '}`;
    }
    if (address.addressLineTwo?.trim()) {
      txt_address += `${address.addressLineTwo.trim()}${address.addressLineTwo.trim().endsWith(',') ? ' ' : ', '}`;
    }
    if (address.addressLineThree?.trim()) {
      txt_address += `${address.addressLineThree.trim()}${address.addressLineThree.trim().endsWith(',') ? ' ' : ', '}`;
    }
    if (address.city?.trim()) {
      txt_address += `${address.city.trim()}${address.city.trim().endsWith(',') ? ' ' : ', '}`;
    }
    if (address.country?.trim()) {
      txt_address += `${address.country.trim()}${address.country.trim() ? ' ' : ', '}`;
    }
    return txt_address.trim();
  }

  onOptionSelected(id: number) {
    this.isListVisible = false
    this.selectedAddress.emit(id)
    const address = this.options().find((address) => address.id === id)
    if (address) {
      this.addressText.set(address.text)
    }
  }

  toggleDropdown() {
    if (!this.isDisabled()) {
      this.isListVisible = !this.isListVisible;
    }
  }

  openDropdown() {
    if (!this.isDisabled() && !this.isListVisible) {
      this.isListVisible = true;
    }
  }

  isDisabled(): boolean {
    return this.deliveredQty > 0;
  }

  @HostListener('document:click', ['$event'])
  clickOutsideDropdown(event: any) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isListVisible = false
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: KeyboardEvent) {
    this.isListVisible = false
  }
}
